import React from 'react';

import { EmbedCarouselPanel } from '../embed-carousel-panel';
import { useEmbedCollectionCarousel } from './use-embed-collection-carousel';

export function EmbedCollectionCarousel({ dispensary, collections }) {
  const {
    carouselTheme,
    currentCollection,
    handleCollectionSelect,
    handleMenuUrlChange,
    hideTitle,
    hideViewAllLink,
    menuUrl,
    menuUrlInputError,
    script,
    setCarouselTheme,
    setHideTitle,
    setHideViewAllLink,
  } = useEmbedCollectionCarousel({ dispensary, collections });

  return (
    <EmbedCarouselPanel
      title='Embed a Collection Carousel'
      detail={
        <>
          Select any collection below to embed its carousel on your website. <b>Note:</b> Unlike homepage sections,
          collections don&apos;t need to be published to your homepage to be embedded here.
        </>
      }
      selectFieldTitle='Collection'
      selectFieldTestId='collection-select'
      selectFieldValue={currentCollection?.value}
      selectFieldOptions={collections}
      onSelectFieldChange={handleCollectionSelect}
      hideTitle={hideTitle}
      onToggleHideTitle={() => setHideTitle(!hideTitle)}
      hideViewAllLink={hideViewAllLink}
      onToggleHideViewAllLink={() => setHideViewAllLink(!hideViewAllLink)}
      menuUrlInputId='collection-menu-url-input'
      menuUrl={menuUrl}
      onMenuUrlChange={handleMenuUrlChange}
      menuUrlInputError={menuUrlInputError}
      defaultMenuUrl={dispensary.menuUrl}
      script={script}
      carouselTheme={carouselTheme}
      onCarouselThemeChange={setCarouselTheme}
      themeControlIdPrefix='collection'
      displayScript={!!currentCollection}
      scriptPlaceholderText='Select a collection and add a valid menu URL above to generate the embed script!'
    />
  );
}
